module.exports = __webpack_public_path__ + "media/images/athletes/4331-114b49062a2f5e831888104a22e05cdb.png";